// extracted by mini-css-extract-plugin
module.exports = {"root":"Overlay_root__Gd8nu","close":"Overlay_close__ikb_T"};